export const EMPLOYEES = {
  1: '1-5',
  2: '6-10',
  3: '11-20',
  4: '20-40',
  5: '50- 100',
  6: '100-200',
  7: '200-500',
  8: '500+',
}
